import { EquipmentListStateTypes, EquipmentListActionTypes } from "./EquipmentList.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: EquipmentListStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const EquipmentListReducer = (
  state: EquipmentListStateTypes = INITIAL_STATE,
  action: any
): EquipmentListStateTypes => {
  switch (action.type) {
    case EquipmentListActionTypes.FETCH_ALL_EQUIPMENT_LIST:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case EquipmentListActionTypes.FETCH_ALL_EQUIPMENT_LIST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case EquipmentListActionTypes.FETCH_ALL_EQUIPMENT_LIST_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EquipmentListActionTypes.FETCH_ALL_EQUIPMENT_LIST_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case EquipmentListActionTypes.FETCH_ONE_EQUIPMENT_LIST:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case EquipmentListActionTypes.FETCH_ONE_EQUIPMENT_LIST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case EquipmentListActionTypes.FETCH_ONE_EQUIPMENT_LIST_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EquipmentListActionTypes.FETCH_ONE_EQUIPMENT_LIST_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default EquipmentListReducer;
